function install(Vue, options = {}) {
  /**
   * 检测图片是否存在
   * @param url
   */
  let imageIsExist = function (url) {
    return new Promise((resolve) => {
      var img = new Image();
      img.onload = function () {
        if (this.complete == true) {
          resolve({success:true,width:img.width,height:img.height});
          img = null;
        }
      }
      img.onerror = function () {
        resolve({success:false});
        img = null;
      }
      img.src = url;
    })
  }
  Vue.directive(options.name || 'default-img', async function (el, binding) {//指令名称为：v-default-img
    var isSet = el.getAttribute("isSet")
    if(isSet=='no'){return}
    const imgURL = el.src;//获取图片地址
    const defaultURL = binding.value;
    if (imgURL) {
      const exist = await imageIsExist(imgURL);
      if (exist.success) {
        el.setAttribute('isSet', "no");
        el.setAttribute('src', imgURL);
        if(exist.width>exist.height){
          let b = 80/exist.width
          let h = Math.round(exist.height*b)
          let top =( 80 - h ) /2
          el.setAttribute('width', '80px');
          el.setAttribute('height', 'auto');
          el.style.top = top+'px'
        }else if(exist.width<exist.height){
          el.setAttribute('height', '80px');
          el.setAttribute('width', 'auto');
        }else{
          el.setAttribute('height', '80px');
          el.setAttribute('width', '80px');
        }
      } else {
        el.setAttribute('isSet', "no");
        el.setAttribute('src', defaultURL);
      }
    } else {
      el.setAttribute('isSet', "no");
      el.setAttribute('src', defaultURL);
    }
  })
}

export default { install };



// WEBPACK FOOTER //
// ./src/assets/js/defaultImg.js